<template>
	<v-dialog
		v-model="modal"
		width="500">
		<v-card>
			<v-card-title
				class="headline primary"
				primary-title>
				Edytuj nazwę
			</v-card-title>

			<div class="text-xs-center">
				<v-card-text>
					<span>Nazwa</span>
					<v-flex>
						<v-text-field
							browser-autocomplete="off"
							label="nazwa"
							aria-label="name"
							for="edit-name-modal"
							id="edit-name-modal"
							type="text"
							v-model="temporaryName"
							outline
						></v-text-field>
					</v-flex>
				</v-card-text>
			</div>

			<v-divider></v-divider>

			<v-card-actions>
				<v-spacer></v-spacer>
				<v-btn
					color="primary"
					@click="rename"
				>
					Zastosuj
				</v-btn>
				<v-btn
					class="button-close"
					color="blue"
					@click="closeModal">
					Anuluj
				</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
	export default {
		name: "EditNameModal",

		methods: {
			closeModal() {
				this.modal = false;
			},

			rename() {
				this.$emit("rename", {name: this.temporaryName, index: this.index});
				this.modal = false;
			},

			openModal(name, index) {
				this.modal = true;
				this.temporaryName = name;
				this.index = index;
			},
		},

		data() {
			return {
				modal: false,
				temporaryName: "",
				index: "",
			};
		},
	};
</script>

<style scoped>
	.headline {
		color: #fff;
	}
	.button-close {
		background-color:  #0052A5;
	}
	.button-close:hover {
		background-color: #0075E2;
	}
</style>
